<template>
  <section
    id="fa7"
    class="padding-top-5xl"
  >
    <div class="row text-center">
      <div class="column-12">
        <h2
          class="text-uppercase size-md with-anchor"
          style="letter-spacing: var(--letter-spacing-3xl); font-weight: var(--font-weight-black); color: var(--fa-dk-yellow)"
        >
          <anchor-link
            anchor="#fa7"
            link-color="yellow"
            anchor-name="Announcing Font Awesome 7"
          />
          New Recipe. Same Great Taste.
        </h2>
        <h1 class="h2 margin-y-md">
          Font Awesome 7
          <span
            class="tag yellow margin-left-xs size-2xs"
            style="--tag-border-radius: var(--border-radius-sm); --tag-padding: var(--spacing-3xs) var(--spacing-2xs) var(--spacing-2xs) var(--spacing-sm)"
            ><span style="font-size: var(--font-size-xs); font-weight: var(--font-weight-black); letter-spacing: var(--letter-spacing-3xl)">Pro</span></span
          >
        </h1>
        <p class="line-length-xl margin-auto">
          The next generation of the internet's favorite icon library and toolkit is here. Featuring more icons, better performance, and new ways to make your
          designs look (and taste?) great.
          <site-link
            :to="{ name: 'plans' }"
            @click.native="$posthog.capture('upgrade_link_click', { context: 'home_view' })"
            >Available now in all Pro plans</site-link
          >!
        </p>
      </div>
    </div>

    <div class="row">
      <div class="column-12 tablet:column-8 tablet:offset-2">
        <form
          class="icons-search form line-length-md padding-y-4xl margin-bottom-sm margin-auto"
          style="--form-button-margin: 0"
          @submit.prevent="search"
        >
          <div
            class="with-icon-before"
            style="--input-with-icon-color: var(--fa-navy); --input-border-color: var(--fa-navy); --input-placeholder-color: var(--fa-md-gravy)"
          >
            <font-awesome-icon
              :icon="$v7.solid.faMagnifyingGlass"
              style="line-height: 1"
            />
            <label
              for="icons-search"
              class="sr-only"
            >
              Search for Icons
            </label>
            <input
              id="search"
              v-model="query"
              type="text"
              name="icons-search"
              class="rounded"
              :placeholder="`Search for icons...`"
            />
            <button
              type="submit"
              class="sr-only"
            >
              Search for Icons
            </button>
          </div>
        </form>
      </div>
    </div>

    <div
      class="fa7-pro-features-card-grid"
      style="--top-tag-margin-top: 0"
    >
      <site-link
        :to="$search({ iconCollections: ['pro-collection'] })"
        class="card-1 card roomy white with-top-tag"
        style="height: 100%; --card-header-background: var(--white); --card-header-color: var(--fa-navy)"
      >
        <span class="tag top yellow">Updated!</span>
        <div
          class="section padding-y-0 display-flex align-center"
          style="overflow: hidden"
        >
          <img
            src="https://img.fortawesome.com/1ce05b4b/v7-icon-grids.png"
            alt="Illustration of Version 7 Icon Key Frames"
          />
        </div>
        <div
          class="header padding-bottom-0"
          style="text-align: left"
        >
          <h4>Revamped + Refreshed Icons</h4>
          <p class="muted">We've lovingly refined the designs for most of our core icons, using more consistent keyshapes and square canvases.</p>
        </div>
      </site-link>

      <site-link
        :to="$search({ new: true })"
        class="card-2 card roomy header yellow with-top-tag"
        style="height: 100%"
      >
        <span class="tag top secondary">New!</span>
        <div
          class="section padding-y-0 display-flex align-center"
          style="overflow: hidden"
        >
          <img
            src="https://img.fortawesome.com/1ce05b4b/v7-new-icon.png"
            alt="Fresh new icons for Version 7"
          />
        </div>
        <div
          class="header padding-bottom-0"
          style="text-align: left"
        >
          <h4>Fresh New Icons</h4>
          <p>The initial release of Font Awesome 7 includes over 300 brand-new icons, with more on the way!</p>
        </div>
      </site-link>

      <site-link
        :to="$docs('/web/add-icons/icon-wizard')"
        class="card-3 card with-top-tag inverted margin-bottom-0"
      >
        <div class="text-left padding-bottom-lg">
          <font-awesome-icon
            :icon="$v7.solid.faSquareDashedCirclePlus"
            size="2x"
          />
        </div>
        <div class="text-left">
          <h4>New Modifiers!</h4>
          <p>Create 11+ million possible icons with the Icon Wizard.</p>
        </div>
      </site-link>

      <site-link
        :to="$docs('/web/add-icons/upload-icons')"
        class="card-4 card with-top-tag margin-bottom-0"
      >
        <div class="text-left padding-bottom-lg">
          <font-awesome-icon
            :icon="$v7.solid.faCloudArrowUp"
            size="2x"
          />
        </div>
        <div class="text-left">
          <h4>Icon Upload!</h4>
          <p>Easily upload new icons to use alongside existing Font Awesome icons.</p>
        </div>
      </site-link>
    </div>
    <div class="padding-top-3xl">
      <h2
        class="text-uppercase size-md text-center margin-bottom-2xl"
        style="letter-spacing: var(--letter-spacing-3xl); font-weight: var(--font-weight-black)"
      >
        Included Icon Packs
      </h2>
      <icon-pack-cards
        collection-name="pro-collection"
        add-brands
      />
    </div>
  </section>
</template>

<script>
  import IconPackCards from '../components/IconPackCards'
  import AnchorLink from '../components/AnchorLink'

  export default {
    name: 'Fa7Pro',

    components: {
      IconPackCards,
      AnchorLink
    },

    props: {
      isSignedIn: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        query: ''
      }
    },

    methods: {
      search() {
        this.$router.push({ name: 'latest.search', query: { q: this.query } })
      }
    }
  }
</script>
